import { AmChart, AmChartsService } from '@amcharts/amcharts3-angular';
import { Component } from '@angular/core';
import { ChartRelativeInput, LinesChartParams } from 'emma-common-ts/emma';
import { reverse, sortBy } from 'lodash';

import { EMMAChartAms } from './emma-chart-ams';
import { lineStyles } from './emma-trapezoidchart.component.helpers';

export type TrapezoidChartGraph = Pick<LinesChartParams, 'title' | 'label' | 'loading'> & {
  value: number;
};
export interface TrapezoidChartInput {
  graph: TrapezoidChartGraph;
  error?: Error;
}

@Component({
    selector: 'emma-trapezoidchart',
    templateUrl: './emma-chart.template.html',
    standalone: false
})
export class EMMATrapezoidChartComponent extends EMMAChartAms {
  protected override chart: AmChart | undefined;
  protected override data: { graphs: TrapezoidChartGraph[] };

  constructor(protected override AmCharts: AmChartsService) {
    super(AmCharts);
    this.data = { graphs: [] };
  }

  protected override _updateChart = () => {
    if (!this.chart) {
      console.warn('No Chart to update');
      return;
    }
    const chartGraphs: any[] = [];
    this.data.graphs.forEach((graph, i) => {
      if (graph) {
        const style: any = { ...lineStyles[i] };
        chartGraphs.push({
          ...style,
          ...graph,
        });
      }
    });

    const chart = this.chart;
    const max = chartGraphs.reduce<number>(
      (acc: number, g) => (g && !g.loading && acc < g.value ? g.value : acc),
      0
    );
    const min = chartGraphs.reduce<number>(
      (acc: number, g) => (g && !g.loading && acc > g.value ? g.value : acc),
      max
    );
    const neckProportion = min && max ? min / max : 0.3;
    this.AmCharts.updateChart(this.chart, () => {
      chart.neckWidth = `${neckProportion * 100}%`;
      chart.dataProvider = reverse(sortBy(chartGraphs, 'value'));
    });
  };

  addValue(graph: TrapezoidChartGraph, options: any = {}) {
    if (graph) {
      // Merge data
      const idx = this.data.graphs.findIndex((g) => g.label === graph.label);
      if (idx >= 0) {
        this.data.graphs[idx] = { ...graph };
      } else {
        this.data.graphs.push(graph);
      }
      if (graph.loading) {
        this.loading(graph);
      } else {
        this.loaded(graph);
      }
    }
    this._updateChart();
  }

  override update(data: ChartRelativeInput, options?: any): void {
    if (data.error) {
      return this.error(data.error);
    } else {
      this.addValue(
        {
          title: data.title || data.label,
          label: data.label,
          value: data.total,
          loading: data.loading || false,
        },
        options
      );
    }
  }
}
